import React, { useState, useEffect } from 'react';
import StatistiquesSection from '../components/admin/StatistiquesSection';
import ServicesSection from '../components/admin/ServicesSection';
import HistoriqueSection from '../components/admin/HistoriqueSection';
import PaymentSuccessModal from '../components/admin/PaymentSuccessModal';
import PaymentFailureModal from '../components/admin/PaymentFailureModal';

const AdminDashboard = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [paymentSessionId, setPaymentSessionId] = useState(null);

  // États pour la gestion des erreurs de paiement
  const [showPaymentFailure, setShowPaymentFailure] = useState(false);
  const [paymentErrorType, setPaymentErrorType] = useState(null);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState(null);

  // Détecter les paramètres de paiement dans l'URL (succès, erreur, annulation)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentSuccess = urlParams.get('payment_success');
    const paymentCancelled = urlParams.get('payment_cancelled');
    const paymentFailed = urlParams.get('payment_failed');
    const paymentError = urlParams.get('payment_error');
    const sessionId = urlParams.get('session_id');
    const errorMessage = urlParams.get('error_message');

    // DEBUG: Afficher tous les paramètres
    // console.log('🔍 DEBUG URL:', window.location.href);
    // console.log('🔍 DEBUG payment_success:', paymentSuccess);
    // console.log('🔍 DEBUG payment_cancelled:', paymentCancelled);
    // console.log('🔍 DEBUG payment_failed:', paymentFailed);
    // console.log('🔍 DEBUG payment_error:', paymentError);
    // console.log('🔍 DEBUG session_id:', sessionId);
    // console.log('🔍 DEBUG error_message:', errorMessage);
    // console.log('🔍 DEBUG tous les params:', [...urlParams.entries()]);

    // Gestion du succès de paiement
    if (paymentSuccess === 'true' && sessionId) {
      console.log('✅ Succès de paiement détecté, affichage modal avec session_id:', sessionId);
      setPaymentSessionId(sessionId);
      setShowPaymentSuccess(true);
    }

    // Gestion de l'annulation de paiement
    else if (paymentCancelled === 'true') {
      console.log('⚠️ Annulation de paiement détectée');
      setPaymentErrorType('cancelled');
      setPaymentErrorMessage('Paiement annulé par l\'utilisateur');
      setShowPaymentFailure(true);
    }

    // Gestion de l'échec de paiement
    else if (paymentFailed === 'true') {
      console.log('❌ Échec de paiement détecté');
      setPaymentErrorType('failed');
      setPaymentErrorMessage(errorMessage || 'Le paiement a échoué');
      setShowPaymentFailure(true);
    }

    // Gestion des erreurs générales
    else if (paymentError) {
      console.log('🚫 Erreur de paiement détectée:', paymentError);
      setPaymentErrorType(paymentError);
      setPaymentErrorMessage(errorMessage || 'Une erreur est survenue');
      setShowPaymentFailure(true);
    }

    else {
      console.log('ℹ️ Aucun paramètre de paiement détecté');
    }

    // Nettoyer l'URL après traitement des paramètres
    if (paymentSuccess || paymentCancelled || paymentFailed || paymentError) {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, []);

  const handleDataChange = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleClosePaymentSuccess = () => {
    setShowPaymentSuccess(false);
    setPaymentSessionId(null);
    // Rafraîchir les données pour voir la nouvelle souscription
    handleDataChange();
  };

  const handleClosePaymentFailure = () => {
    setShowPaymentFailure(false);
    setPaymentErrorType(null);
    setPaymentErrorMessage(null);
    // Rafraîchir les données au cas où
    handleDataChange();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Boaz-Housing Admin</h1>
              <p className="text-gray-600 mt-2">Gestion des souscriptions et services</p>
            </div>
          </div>
        </div>

        {/* Section Services - EN PREMIER (bouton Souscrire) */}
        <ServicesSection onDataChange={handleDataChange} />

        {/* Section Statistiques - EN DEUXIÈME */}
        <StatistiquesSection />

        {/* Section Historique - EN TROISIÈME */}
        <HistoriqueSection key={refreshKey} onDataChange={handleDataChange} />
      </div>

      {/* Modal de succès de paiement Stripe */}
      <PaymentSuccessModal
        show={showPaymentSuccess}
        onClose={handleClosePaymentSuccess}
        sessionId={paymentSessionId}
      />

      {/* Modal d'erreur de paiement Stripe */}
      <PaymentFailureModal
        show={showPaymentFailure}
        onClose={handleClosePaymentFailure}
        errorType={paymentErrorType}
        errorMessage={paymentErrorMessage}
      />
    </div>
  );
};

export default AdminDashboard;